import { generateSetChild } from '@/helpers/VuexHelpers'
import { service } from '@/service'
import { config } from '@/config'
import dayjs from '@/helpers/dayjs'

export default {
  namespaced: true,
  state: {
    lastOrders: [],
    address: null,
    loggedin: false,
    firstName: "",
    accountLoading: true
  },
  actions: {
    async getLastOrders ({ commit }) {
      commit('setAccountLoading', {item: true})
      const result = await service.accountLastOrders()
      const lastOrders = []
      if (result.success) { // TODO: this is currently the only non hacky way to check if this is valid
        lastOrders.push({
          createDate: result.order.createDate,
          price: result.order.price,
          priceFormatted: result.order.priceFormatted,
          description: result.basket
            .map(v => v.name)
            .join(', '),
          formData: result.formData,
          // HACK: we force currently the first valid formdata type
          deliveryType: result.type,
          store: result.store
        })
        let firstName = ''
        try {
          firstName = result.formData[0].post.customerDataset.user_name
        } catch (err) {
          console.warn('account: failed to read firstName form order')
        }
        commit('setFirstName', { item: firstName })

        const address = result.defaultAddress
        commit('setAddress', { item: address })
      }
      commit('setLoggedIn', { item: result.isLoggedIn === true })
      commit('setLastOrders', { item: lastOrders })
      commit('setAccountLoading', { item: false })
    },
    async insertOrder ({ commit }, { order, deliveryType }) {
      const delivery = order.formData.find(v => v.type === deliveryType)
      if (delivery == null) {
        throw new Error('order has now valid delivery matching delivery type')
      }
      const url = delivery.url
      return service.accountSelectOrder({
        json: {
          ...delivery.post,
          resultReturn: '1'
        },
        url
      })
    },
    async orderWithAccount ({ commit }, { order, deliveryType }) {
      const delivery = order.formData.find(v => v.type === deliveryType)
      if (delivery == null) {
        throw new Error('order has now valid delivery matching delivery type')
      }
      const url = delivery.url
      return service.accountSelectOrder({
        json: {
          ...delivery.post,
          resultReturn: '1'
        },
        url
      })
    }
  },
  getters: {
    accountFirstName (state) {
      return state.firstName
    },
    accountLastOrder (state) {
      return state.lastOrders
        .map(v => {
          const lastOrder = {
            ...v,
            date: dayjs(v.date)
          }
          return lastOrder
        })[0]
    },
    accountLoggedIn (state) {
      return state.loggedin
    },
    accountLoading (state) {
      return state.accountLoading
    },
    accountProfileUrl (state) {
      return config.WEBSHOP_ENDPOINT +
        (
          state.loggedin
            ? '/customerdata/overview'
            : '/#login'
        )
    },
    accountAddress (state) {
      return state.address
    }
  },
  mutations: {
    setLastOrders: generateSetChild('lastOrders'),
    setLoggedIn: generateSetChild('loggedin'),
    setFirstName: generateSetChild('firstName'),
    setAccountLoading: generateSetChild('accountLoading'),
    setAddress: generateSetChild('address')
  }
}
